/**
 * Branding asset URL helpers — runtime loading only (save accepts any http(s) URL via API).
 */

export const isHttpUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const t = url.trim();
    if (!t) return false;
    return /^https?:\/\//i.test(t) || /\/local\//i.test(t) || /\/branding\//i.test(t);
};

/** Google Fonts embed CSS, e.g. https://fonts.googleapis.com/css2?family=Roboto&display=swap */
export const isGoogleFontsCssUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const u = url.trim().toLowerCase();
    return u.includes('fonts.googleapis.com/css');
};

export const isFontFileUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const u = url.trim().toLowerCase();
    if (!u) return false;
    if (u.includes('/branding/') && /\/fonts\//.test(u)) return true;
    if (u.includes('/local/') && /\.(woff2?|ttf|otf|eot)(\?|$)/.test(u)) return true;
    if (/\.(woff2?|ttf|otf|eot)(\?|#|$)/i.test(u)) return true;
    if (u.includes('fonts.gstatic.com/')) return true;
    return false;
};

export const parseGoogleFontFamily = (url) => {
    if (!isGoogleFontsCssUrl(url)) return null;
    try {
        const u = new URL(url.trim());
        const family = u.searchParams.get('family');
        if (!family) return null;
        const name = decodeURIComponent(family.split(':')[0].replace(/\+/g, ' ')).trim();
        return name ? `"${name}", sans-serif` : null;
    } catch {
        return null;
    }
};

export const resolveBrandFontFamily = (url, fallbackFaceName) => {
    if (isGoogleFontsCssUrl(url)) return parseGoogleFontFamily(url);
    if (isFontFileUrl(url)) return `"${fallbackFaceName}", sans-serif`;
    return null;
};

export const fontFormatHint = (url) => {
    const u = String(url || '').toLowerCase();
    if (u.includes('.woff2')) return 'woff2';
    if (u.includes('.woff')) return 'woff';
    if (u.includes('.otf')) return 'opentype';
    if (u.includes('.ttf')) return 'truetype';
    return 'woff2';
};
